import { render, staticRenderFns } from "./DesignPaperTilesNonMessage.vue?vue&type=template&id=43412d8c&scoped=true&"
import script from "./DesignPaperTilesNonMessage.vue?vue&type=script&lang=js&"
export * from "./DesignPaperTilesNonMessage.vue?vue&type=script&lang=js&"
import style0 from "./DesignPaperTilesNonMessage.vue?vue&type=style&index=0&id=43412d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43412d8c",
  null
  
)

export default component.exports